import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import SectionHeader from "../components/SectionHeader";

export default function NewsPage() {
  const [news, setNews] = useState([]);
  useEffect(() => {
    document.title = "News & Press — Je Ke Pictures";
    api.get("/news").then(r => setNews(r.data)).catch(() => {});
  }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="news-page">
      <SectionHeader eyebrow="Newsroom" title="News & Press" subtitle="Announcements, press releases, and media coverage from Je Ke Pictures." />
      <div className="space-y-6">
        {news.map((n) => (
          <article key={n.id} className="grid grid-cols-1 md:grid-cols-12 gap-6 py-8 border-b border-white/5 group hover:border-[color:var(--jk-gold)]/30 transition-colors" data-testid={`news-item-${n.id}`}>
            <div className="md:col-span-2">
              <div className="font-cinzel text-[0.65rem] tracking-[0.3em] text-[color:var(--jk-gold)] uppercase">{n.category}</div>
              <div className="text-xs text-[color:var(--jk-muted)] mt-1">{new Date(n.published_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</div>
            </div>
            <div className="md:col-span-10">
              <h3 className="font-cinzel font-bold text-2xl md:text-3xl mb-3 group-hover:text-[color:var(--jk-gold)] transition-colors">{n.title}</h3>
              <p className="text-[color:var(--jk-muted)] leading-relaxed max-w-3xl">{n.excerpt || n.body}</p>
              {n.source_url && (
                <a href={n.source_url} target="_blank" rel="noreferrer" className="jk-link inline-block mt-4">Read More →</a>
              )}
            </div>
          </article>
        ))}
        {news.length === 0 && <div className="text-[color:var(--jk-muted)]">No news yet.</div>}
      </div>
    </div>
  );
}
